import type {SelectHierarchy, SelectHierarchyItem} from "@t/ui/SelectHierarchy.ts";

export function findItemIn(id: string, items:SelectHierarchyItem[]):SelectHierarchyItem|null {
	for (let item of items) {
		if (item.id === id) return item;
		if (Array.isArray(item?.submenu?.items)) {
			const found = findItemIn(id, item.submenu.items);
			if (found) return found;
		}
	}
	return null;
}

export interface SHPathItem {
	list: SelectHierarchy,
	index: number;
}

export function pathTo(id: string, submenu:SelectHierarchy):SHPathItem[] {
	if (Array.isArray(submenu?.items)) {
		for (let i = 0; i < submenu.items.length; i++) {
			const item = submenu.items[i];
			if (item.id === id) {
				return [ { list:submenu, index: i } ];
			}
			if (item.submenu) {
				const pt = pathTo(id, item.submenu);
				if (pt.length > 0) {
					pt.splice(0, 0, { list:submenu, index: i });
					return pt;
				}
			}
		}
	}
	return [];
}